'use client';

import { Box, Stack, Typography } from '@castlery/fortress';
import { useCallback } from 'react';
import { SellFilled } from '@castlery/fortress/Icons';

interface ProductDyPromotionItemProps {
  selector: string;
  // data tracking prop
  rank: string;
  promotionData?: any;
}

export const ProductDyPromotionItem = (props: ProductDyPromotionItemProps) => {
  const { promotionData } = props;

  // const user = useAppSelector(selectedActiveUser);
  // const productSkuInfo = useMemo(() => {
  //   return {
  //     sku: variant?.sku,
  //     skuName: variant?.product_name,
  //   };
  // }, [variant?.product_name, variant?.sku]);

  // 事件追踪 - impression
  //   useEffect(() => {
  //     if (promotionData?.rawData && productSkuInfo.sku) {
  //       try {
  //         // 创建 PDP promotion impression 事件
  //         if (window.dataLayer) {
  //           window.dataLayer.push({
  //             event: 'pdp_promotion_impression',
  //             promotion_rank: rank,
  //             promotion_selector: selector,
  //             product_sku: productSkuInfo.sku,
  //             product_name: productSkuInfo.skuName,
  //             dy_decision_id: promotionData.rawData.decisionId,
  //             dy_variation_id: promotionData.rawData.variationId,
  //           });
  //         }
  //       } catch (error) {
  //         console.error('PDP Promotion impression tracking error:', error);
  //       }
  //     }
  //   }, [promotionData, productSkuInfo, rank, selector]);
  //   useEffect(() => {
  //     dispatch({
  //       type: EVENT_PDP_DETAILS,
  //       result: {
  //         detailAction: `impression_product_promotion${rank}`,
  //         skuId: productSkuInfo.sku,
  //         skuName: productSkuInfo.skuName,
  //       },
  //     });
  //   }, [productSkuInfo, dispatch, rank]);

  // 处理点击事件
  const handlePromotionClick = useCallback(async (event: React.MouseEvent) => {
    let href = '';
    const aTagElement = (event.target as HTMLElement).closest('a');
    if (aTagElement && aTagElement.tagName === 'A') {
      href = aTagElement.getAttribute('href') || '';
    }

    const reportEvent = () => {
      // try {
      //   // 创建 PDP promotion click 事件
      //   if (window.dataLayer) {
      //     window.dataLayer.push({
      //       event: 'pdp_promotion_click',
      //       promotion_rank: rank,
      //       promotion_selector: selector,
      //       product_sku: productSkuInfo.sku,
      //       product_name: productSkuInfo.skuName,
      //       dy_decision_id: promotionData?.rawData?.decisionId,
      //       dy_variation_id: promotionData?.rawData?.variationId,
      //       promotion_url: href,
      //     });
      //   }
      // } catch (error) {
      //   console.error('PDP Promotion click tracking error:', error);
      // }
    };

    // 处理链接跳转
    if (!event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      reportEvent();
      if (href) {
        window.location.href = href;
      }
    } else {
      reportEvent();
    }
  }, []);

  // 处理模板内的链接点击
  const handleTemplateClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.target instanceof HTMLElement) {
        const target = event.target;
        if (target.tagName === 'A' || target.tagName === 'B') {
          handlePromotionClick(event);
        }
      }
    },
    [handlePromotionClick]
  );

  //   const handleView = async (event) => {
  //     let href = '';
  //     const aTagElement = event.target.closest('a');
  //     if (aTagElement && aTagElement.tagName === 'A') {
  //       href = aTagElement.getAttribute('href');
  //     }
  //     const reportEvent = () => {
  //       dispatch({
  //         type: EVENT_PDP_DETAILS,
  //         result: {
  //           detailAction: `click_product_promotion${rank}`,
  //           skuId: productSkuInfo.sku,
  //           skuName: productSkuInfo.skuName,
  //           dyReportData: {
  //             decisionId: PDPPromotion?.decisionId,
  //             variationId: PDPPromotion?.variationId,
  //           },
  //         },
  //       });
  //     };
  //     if (!event.ctrlKey && !event.metaKey) {
  //       event.preventDefault();
  //       await reportEvent();
  //     } else {
  //       reportEvent();
  //     }
  //     window.location.href = href;
  //   };

  //   const handleHrefClick = (event) => {
  //     if (event.target.tagName === 'A' || event.target.tagName === 'B') {
  //       handleView(event);
  //     }
  //   };

  return (
    <Stack direction="row" alignItems="flex-start" gap={1}>
      <>
        <SellFilled
          sx={{
            width: 20,
            height: 20,
            color: 'var(--fortress-palette-brand-burntOrange-500)',
          }}
        />
        {/* 渲染 DY 模板内容 */}
        <Typography
          variant="plain"
          level="caption1"
          sx={{
            width: '100%',
            '& a': {
              color: 'var(--fortress-palette-brand-burntOrange-500) !important',
            },
            py: 0,
            px: 0,
          }}
        >
          <Box
            sx={{
              a: {
                ml: 1,
              },
            }}
            dangerouslySetInnerHTML={{
              __html: promotionData?.templateCode,
            }}
            onClick={handleTemplateClick}
          />
        </Typography>
      </>
    </Stack>
  );
};
